import test from "./components/test/test";
import MapContainer from "./components/map/MapContainer";
import EditArea from "./tool/edit/EditArea";
import StateManager from "./tool/edit/StateManager";
import Graffiti from "./tool/edit/Graffiti";
import DrawArea from "./tool/edit/DrawArea";
import ClickEdit from "./tool/edit/ClickEdit";
import SelectPolygon from "./tool/edit/SelectPolygon";
import SelectLine from "./tool/edit/SelectLine";
import SelectPoint from "./tool/edit/SelectPoint";
import LongTouch from "./tool/longTouch/LongTouch";
import Touch from "./tool/touch/Touch";
import MapCommon from "./common/MapCommon";
import MiniMap from "./components/control/MiniMap";
import DrawAreaControl from "./tool/control/DrawAreaControl";
import CompassControl from "./tool/control/CompassControl";
import LayerControl from "./components/LayerControl/LayerControl";
import PieCustomLayer from "./layer/PieCustomLayer";
import BarCustomLayer from "./layer/BarCustomLayer";
import LineCustomLayer from "./layer/LineCustomLayer";
import DrawLineTool from "./tool/edit/DrawLineTool";
import SplitTool from "./tool/edit/SplitTool";
import DeductTool from "./tool/edit/DeductTool";
import MergeTool from "./tool/edit/MergeTool";
import DrawPointTool from "./tool/edit/DrawPointTool";
import * as  ToolType from "./tool/edit/ToolType";

import NewTree from "./components/Tree/NewTree";


import  "./assets/index.less";
import  "./assets/iconfont.css";
import  "./assets/mapbox-gl-draw.css";
// import "mapbox-gl/dist/mapbox-gl.css"
const components = [
  test,MapContainer
  // ...如果还有的话继续添加
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install.use(window.Vue);
}

export  {
  //总体
  install,
  //支持按需引入
  test,
  EditArea,
  MapContainer,
  MapCommon,
  LongTouch,
  StateManager,
  Graffiti,
  SelectPolygon,
  SelectLine,
  SelectPoint,
  DrawArea,
  ClickEdit,
  MiniMap,
  DrawAreaControl,
  Touch,
  CompassControl,
  LayerControl,
  PieCustomLayer,
  BarCustomLayer,
  LineCustomLayer,
  DrawLineTool,
  MergeTool,
  SplitTool,
  DeductTool,
  DrawPointTool,
  NewTree,
  ToolType
}





// WEBPACK FOOTER //
// ./src/index.js